<i18n>
{
  "en": {
    "menu": {
      "myPage": "Top",
      "editUser": "Edit User",
      "message": "Message",
      "help": "Help",
      "logout": "Logout"
    }
  },
  "ja": {
    "menu": {
      "myPage": "トップ",
      "editUser": "ユーザ情報編集",
      "message": "メッセージ",
      "help": "ヘルプ",
      "logout": "ログアウト"
    }
  }
}
</i18n>

<template>
  <v-layout row wrap>
    <v-flex xs12 sm12 md12>
      <v-toolbar dark>
        <img src="@/assets/headlogo.png" style="margin-left: -16px;" />
        <div class="header-title">
          {{ title }}
        </div>
        <v-spacer></v-spacer>

        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              v-if="isLogin"
              icon
              slot="activator"
              class="hidden-xs-and-up"
              v-on="on"
            >
              <v-icon>menu</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-tile
              @click="goto('/cp/' + getCampaignCode() + '/me')"
            >
              <v-list-tile-action-text>
                <v-icon left color="primary">home</v-icon>
              </v-list-tile-action-text>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t('menu.myPage') }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile
              @click="goto('/cp/' + getCampaignCode() + '/me/edit')"
            >
              <v-list-tile-action-text>
                <v-icon left color="primary">edit</v-icon>
              </v-list-tile-action-text>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t('menu.editUser') }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile
              @click="goto('/cp/' + getCampaignCode() + '/me/help')"
            >
              <v-list-tile-action-text>
                <v-icon left color="primary">help</v-icon>
              </v-list-tile-action-text>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t('menu.help') }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile
              @click="goto('/cp/' + getCampaignCode() + '/logout')"
            >
              <v-list-tile-action-text>
                <v-icon left color="primary">exit_to_app</v-icon>
              </v-list-tile-action-text>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t('menu.logout') }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar>
    </v-flex>
  </v-layout>
</template>

<script>
import TokenManager from '@/utils/TokenManager';
import StorageManager from '@/utils/StorageManager';

export default {
  props: {
    title: String
  },
  methods: {
    goto(path) {
      if (this.$route.path != path) {
        this.$router.push(path)
      }
    },
    donothing: () => {},
    getCampaignCode: () => {
      return StorageManager.getItem('CAMPAIGN_CODE_SESSION_KEY');
    }
  },
  computed: {
    isLogin: () => TokenManager.isLogin()
  },
  data() {
    return {
      logo_src: require('../../assets/logo.png'),
      languages: ['en', 'jp']
    };
  }
};
</script>

<style lang="stylus" scoped>
nav.v-toolbar {
  background-color: #385168
}
.header-title {
  margin-left: 16px;
  cursor : pointer;
}

</style>
